<script setup>
  import {onMounted, onUnmounted, ref} from "vue";

  defineOptions({
    name: "ComponentDropdown",
    inheritAttrs: false,
  });

  defineProps({
    alignment: {
      type: String,
      default: "right",
      validator: (value) => ["left", "right"].includes(value),
    },
    innerClass: {
      type: String,
      default: "",
    },
  });

  const refDropdown = ref(null);

  const visible = ref(false);
  const id = "dropdown-" + Math.random().toString(16).slice(2);

  onMounted(() => {
    globalThis.addEventListener("click", closeDropdownOnOutsideClick);
  });

  onUnmounted(() => {
    globalThis.addEventListener("click", closeDropdownOnOutsideClick);
  });

  function close() {
    visible.value = false;
  }

  const closeDropdownOnOutsideClick = (event) => {
    if (visible.value && !refDropdown.value?.contains(event.target)) visible.value = false;
  };

  defineExpose({
    close,
  });
</script>

<template>
  <div ref="refDropdown" class="relative">
    <button
      :class="$attrs['class']"
      type="button"
      :aria-controls="id"
      :aria-expanded="visible"
      :data-test="getTestId('dropdown-trigger')"
      class="enabled:cursor-pointer"
      :data-med-state="visible ? 'open' : 'closed'"
      @click="visible = !visible"
    >
      <slot name="button" />
    </button>

    <!-- Dropdown section, show/hide based on state. -->
    <div
      v-if="visible"
      :id="id"
      class="absolute right-0 z-10 mt-1 overflow-visible shadow-md"
      :class="['bg-white', innerClass, {'right-0': alignment === 'right', 'left-0': alignment === 'left'}]"
      :data-test="getTestId('dropdown-body')"
    >
      <slot name="dropdown" />
    </div>
  </div>
</template>
